/**
 * Created by ronmarsiano on 05/03/2018.
 */


function NetworksRulesConfigCtrl($sce, $scope, $timeout, $state, $controller, IconsService){



    $scope.networkRulesProperties = {wasChanged : false};


    $scope.$root.hasChanges = function(){
        return $scope.networkRulesProperties.wasChanged;
    };

    function handleNetworkRulesSave() {
        if($scope.networkRulesProperties.wasChanged){
            $scope.networkRulesProperties.onNetworkRulesSave();
        }
    }

    /**
     * setting the default values for the network rules where external meaning the internet
     * and internal meaning the WAN , each new rule created will have the default value
     * according to the rule type
     */
    function setDefaultAccelerationValues() {
        if($scope.account.tcpAccelerationExternal){
            $scope.networkRulesProperties.defaultTcpAccelerationExternal = $scope.account.tcpAccelerationExternal;
        }
        if($scope.account.tcpAccelerationInternal){
            $scope.networkRulesProperties.defaultTcpAccelerationInternal = $scope.account.tcpAccelerationInternal;
        }
    }


    function setChanges(type, reset) {
        if (type === 'account') {
            $scope.networkRulesProperties = {wasChanged : false};
            if (reset) {
                $scope.account = angular.copy($scope.orig);
            }
            else {
                $scope.orig = angular.copy($scope.account);
            }
            setDefaultAccelerationValues();
        }
    }

    function loadAccount() {
        store.fetch({
            path: 'getAccountSettings',
            queryParams: { accountId: $state.params.accountId, type: 'account' },
            success: function (data) {
                $scope.account = data;
                if(!$scope.account.itemsToDelete){
                    $scope.account.itemsToDelete = {};
                }
                $scope.account.itemsToDelete.networkRules = [];
                setChanges('account');
            },
        });
    }

    loadAccount();

    function innerSave() {
        $scope.loading = true;
        if($scope.networkRulesProperties && $scope.networkRulesProperties.wasChanged){
            $scope.account.networkRules = angular.copy($scope.networkRulesProperties.networkRules);
            $scope.account.networkRules.forEach(function(networkRule) {
                networkRule.allocatedIps = [];
                delete networkRule.allocatedIps;
                networkRule.crossConnectNat = [];
                delete networkRule.crossConnectNat;

                /*  // the what field is now stored in the whatBuckets object
                 networkRule.whatBuckets.what.items = networkRule.what;
                 delete networkRule.what;*/
            });


            var fields = "['networkRules']";
            // send save request
            $scope.loading = true;
            store.save({
                path: '/edit',
                data: {networkRules:$scope.account.networkRules, newSaveMethod: true, id: $scope.account.id},
                dataObj: 'json',
                queryParams: {
                    accountId: $state.params.accountId,
                    save: true,
                    fields: fields,
                },
                success: function (data) {
                    $scope.loading = false;
                    $scope.$root.handleServerResponse(data, '', 'Account settings saved successfully');
                    if (data.status !== 'ERROR') {
                        handleNetworkRulesSave();
                        //loadAccount();
                    }
                }
            });
        }
    }

    $scope.saveChanges = function () {
        var rules = $scope.networkRulesProperties.networkRules
        .filter(function(rule) {
            return rule.routeType == 'NAT' && rule.allocatedIpsIds.length < 2;
        })
        .map(function(rule) {return "'" + rule.description + "'"});
        if (rules && rules.length) {
            var messageStrings = [];
            var message = messageStrings.concat((rules.length > 1) ? 'Networking rules ' : 'Networking rule ')
                .concat(rules.join(', '))
                .concat((rules.length > 1) ? ' are ' : ' is ')
                .concat('only configured for one NAT routing egress IP address. We recommend that there are at least two egress IP addresses to provide resiliency. Do you want to save this configuration?')
                .join('');
            $scope.$root.confirm(message, function() {
                innerSave();
            });
        }
        else
            innerSave();

    };
}